import Big from "big.js";
export function centsToDecimal(amount) {
    return new Big(amount).div(100).toFixed(2);
}
export function decimalToCents(amount) {
    return parseInt(new Big(amount).times(100).toFixed(0), 10);
}
export function percentOfCents(amount, percent) {
    const actualPercent = Big(percent || 0).div(100);
    return parseInt(Big(amount).times(actualPercent).toFixed(0), 10);
}
export function calculateGST(amount) {
    const priceWithoutGst = parseInt(Big(amount).div(1.15).toFixed(0), 10);
    return {
        priceWithoutGst: priceWithoutGst,
        priceGstValue: amount - priceWithoutGst,
    };
}
export function formatCurrency(value) {
    if (value < 0) {
        value = typeof value === "string" ? parseInt(value, 10) : value;
        return `-$${centsToDecimal(Math.abs(value))}`;
    }
    return "$" + centsToDecimal(value);
    // return "$" + Big(value).toFixed(2);
}
export function formatCurrencySign(value, show) {
    const base = formatCurrency(value);
    if (value > 0 && (!show || show.indexOf("positive") !== -1))
        return `+${base}`;
    if (value < 0 && (!show || show.indexOf("negative") !== -1))
        return `-${base}`;
    if (value === 0)
        return base;
}
/** Calculate the amount to round a value by so it's cash acceptable */
export function calculateMoneyRounding(amount) {
    const lastDigitOfAmount = amount % 10;
    let value;
    // tslint:disable-next-line:prefer-conditional-expression
    if (lastDigitOfAmount <= 5) {
        value = -lastDigitOfAmount;
    }
    else {
        value = 10 - lastDigitOfAmount;
    }
    // This check is there to prevent -0 from being returned in browsers
    // -0 does === 0 so this check will match properly
    if (value === 0)
        return 0;
    return value;
}
//# sourceMappingURL=index.js.map